import {defineStore} from 'pinia'
import type {Diagnostic} from "~/types/diagnostic";

export const useDiagnosticStore = defineStore('diagnosticStore', () => {
    const runtimeConfig = useRuntimeConfig()
    const decathStore = useDecathlonStores()
    const diagnostic = ref<Diagnostic | undefined>()

    const getAllThemes = () => diagnostic.value?.themes
    const getThemeById = (themeId: string) => {
        const themes = getAllThemes()
        return themes?.find((theme) => theme.id.toString() === themeId)
    }

    const getSubThemeById = (themeId: number, subThemeId: number) => {
        const themes = getAllThemes()
        if (themes) {
            const theme = themes.find((theme) => theme.id === themeId)
            return theme ? theme.subThemes.find((subTheme) => subTheme.id === subThemeId) : undefined
        }
    }

    const fetchDiagnosticByStore = async () => {
        if (decathStore.selectedStore && decathStore.selectedCrossDiag) {
            diagnostic.value = await useFetchWithToken<Diagnostic>('fetchDiagnosticByStore',
                `${runtimeConfig.public.apiBase}/v1/diagnostic/store?storeId=${decathStore.selectedStore.id}&diagnosticId=${decathStore.selectedCrossDiag?.id}`, {
                    method: 'get',
                })
        }
        return diagnostic.value
    }

    const resetDiagnostic = async (scope: string, withArchive: boolean, dateMin?: Date) => {
        if (!decathStore.selectedCrossDiag) return
        const params = new URLSearchParams({
            storeId: decathStore.selectedStore!.id.toString(),
            diagnosticId: decathStore.selectedCrossDiag?.id?.toString() ?? '',
            withArchive: withArchive.toString(),
        })

        if (dateMin) {
            params.set('dateMin', dateMin.toISOString())
        }

        return await useFetchWithToken('resetDiagnostic',
            `${runtimeConfig.public.apiBase}/v1/diagnostic/${scope}/reset?${params.toString()}`, {
                method: 'post',
            })
    }

    const restoreLastDiagnostic = async () => {
        if (!decathStore.selectedCrossDiag) return
        return await useFetchWithToken<Diagnostic>('restoreLastDiagnostic',
            `${runtimeConfig.public.apiBase}/v1/diagnostic/store/archives/restore-last?storeId=${decathStore.selectedStore!.id}&diagnosticId=${decathStore.selectedCrossDiag?.id}`, {
                method: 'post',
            })
    }


    return {
        diagnostic,
        fetchDiagnosticByStore,
        getThemeById,
        getSubThemeById,
        getAllThemes,
        resetDiagnostic,
        restoreLastDiagnostic
    }
})
